const PREFIX = 'com.lordofdisndat.dcc/gm-bridge/v1/';

export function bridgeStorageKey(roomId: string): string {
  return `${PREFIX}${roomId}`;
}

export function readBridgeKey(roomId: string): string {
  try { return globalThis.localStorage?.getItem(bridgeStorageKey(roomId))?.trim() ?? ''; }
  catch { return ''; }
}

export function writeBridgeKey(roomId: string, key: string): boolean {
  try { globalThis.localStorage?.setItem(bridgeStorageKey(roomId), key.trim()); return true; }
  catch { return false; }
}

export function clearBridgeKey(roomId: string): boolean {
  try { globalThis.localStorage?.removeItem(bridgeStorageKey(roomId)); return true; }
  catch { return false; }
}

function bytesToHex(bytes: Uint8Array): string {
  return [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export function generateBridgeKey(): string {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  return bytesToHex(bytes);
}
